import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import staffApi from "../../api/staffApi";
import studentApi from "../../api/studentApi";
import userApi from "../../api/userApi";
import { STATUS } from "../../constant";

export interface AuthState {
  user: any | null;
  loading: boolean;
  error: string | null;
  success: string | null;
}

const initialState: AuthState = {
  user: null,
  loading: false,
  error: null,
  success: null,
};


// 🆕 Đăng ký học sinh
export const createStudent = createAsyncThunk(
  "auth/createStudent",
  async (data: any, { rejectWithValue }) => {
    try {
      const res = await studentApi.createStudent(data);
      return res;
    } catch (err: any) {
      // Trả toàn bộ response để có thể check status ở component
      return rejectWithValue(err.response || { status: 500, data: { message: "Đăng ký thất bại" } });
    }
  }
);

export const createStaff = createAsyncThunk(
  "auth/createStaff",
  async (data: any, { rejectWithValue }) => {
    try {
      const res = await staffApi.createStaff(data);
      return res;
    } catch (err: any) {
      // Trả toàn bộ response để có thể check status ở component
      return rejectWithValue(err.response || { status: STATUS.ERROR, data: { message: "Đăng ký thất bại" } });
    }
  }
);

// ✅ Đăng nhập
export const login = createAsyncThunk(
  "auth/login",
  async (data: { email: string; password: string }, { rejectWithValue }) => {
    try {
      const res = await userApi.login(data);
      return res.data.user;
    } catch (error: any) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

// ✅ Đăng xuất
interface LogoutParams {
  userId: string;
}
export const logout = createAsyncThunk<
  void,
  LogoutParams,
  { rejectValue: string }
>(
  "auth/logout",
  async ({ userId }, { rejectWithValue }) => {
    try {
      await userApi.logout({ userId });
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data?.message || "Đăng xuất thất bại"
      );
    }
  }
);

// ✅ Cập nhật thông tin học sinh
export const updateProfileStudent = createAsyncThunk(
  "auth/update-profile-student",
  async (
    { id, data }: { id: number; data: any },
    { rejectWithValue }
  ) => {
    try {
      const res = await studentApi.updateProfileStudent(id, data);
      return res.data;
    } catch (error: any) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const updateProfileStaff = createAsyncThunk(
  "auth/update-profile-staff",
  async (
    { id, data }: { id: number; data: any },
    { rejectWithValue }
  ) => {
    try {
      const res = await staffApi.updateProfileStaff(id, data);
      return res.data;
    } catch (error: any) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearStatus: (state) => {
      state.error = null;
      state.success = null;
    },
    setUser: (state, action) => {
      state.user = action.payload; // dùng để restore session
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.success = "Đăng nhập thành công!";
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
        state.success = "Đăng xuất thành công!";
      })

      // ✅ THÊM PHẦN NÀY
      .addCase(updateProfileStaff.fulfilled, (state, action) => {
        state.user = {
          ...state.user,
          ...action.payload, // payload trả về từ API
        };
        state.success = "Cập nhật thông tin thành công!";
      })

      .addCase(updateProfileStudent.fulfilled, (state, action) => {
        state.user = {
          ...state.user,
          ...action.payload,
        };
        state.success = "Cập nhật thông tin thành công!";
      });
  }
});


export const { clearStatus, setUser } = authSlice.actions;
export default authSlice.reducer;
